/* eslint-disable import/prefer-default-export */

export function getTcomConfigParam($window, param) {
  return $window.tcom
    && $window.tcom.expertFinder
    && $window.tcom.expertFinder.appConfig
    && $window.tcom.expertFinder.appConfig[param];
}

export function buildQueryParamUrl(url, params = []) {
  return params
    .reduce((val, param, idx) => `${val}${idx ? '&' : '?'}${param}`, url);
}
function arrayToString(data) {
  return data.join(',');
}

function objectKeysToArray(data) {
  return Object.keys(data);
}

function objectKeysToString(data) {
  return arrayToString(objectKeysToArray(data));
}

export function processCompanySize(size) {
  return size.split('-');
}

function formatGenericPayload(data, objectProcessingFunction) {
  const payload = {};

  if (data.myCompanySize) {
    const companySize = processCompanySize(data.myCompanySize);
    payload.fteFrom = parseInt(companySize[0], 10);
    payload.fteTo = parseInt(companySize[1], 10);
  }
  if (data.postCode) {
    payload.postcode = `${data.postCode}`;
  }
  if (data.myLocation) {
    payload.location = data.myLocation;
  }
  if (data.multiCoverage) {
    payload.coverage = objectProcessingFunction(data.multiCoverage);
  }
  if (data.solutions) {
    payload.solutions = objectProcessingFunction(data.solutions);
  }
  if (data.contactTime) {
    payload.contactTime = objectProcessingFunction(data.contactTime);
  }

  return payload;
}

export function formatGenericRequestPayload(data) {
  return formatGenericPayload(data, objectKeysToString);
}

export function formatContactRequestPayload(data) {
  return formatGenericPayload(data, objectKeysToArray);
}

export function formatStateParamsToData(stateParams = {}) {
  const data = {};

  if (stateParams.solutions) {
    let solutions = stateParams.solutions;

    if (angular.isString(solutions)) {
      solutions = [solutions];
    }

    data.solutions = solutions.reduce((a, b) => (
      Object.assign({}, a, {
        [b]: true
      })
    ), {});
  }

  if (stateParams.postcode) {
    data.postCode = stateParams.postcode;
  }

  if (stateParams.location) {
    data.myLocation = stateParams.location;
  }

  if (stateParams.fteFrom && stateParams.fteTo) {
    data.myCompanySize = `${stateParams.fteFrom}-${stateParams.fteTo}`;
  }

  return data;
}



// WEBPACK FOOTER //
// ./src/utils/index.js